/* eslint-disable */
import config from '@/libs/utils/config';
if (config.publicPath) {
  __webpack_public_path__ = config.publicPath;
}
